const componentList = [
    // 基础题型 - start
    {
        group: "basic",
        type: "radio",
        name: "单选题",
        title: "请选择一个选项",
        options: [
            {
                value: "1",
                label: "选项1",
            },
            {
                value: "2",
                label: "选项2",
            },
            {
                value: "3",
                label: "选项3",
            },
        ],
        required: true,
        defaultValue: ""
    },
    {
        group: "basic",
        type: "checkbox",
        name: "多选题",
        title: "请选择以下选项（多选）",
        options: [
            {
                value: "1",
                label: "选项1",
            },
            {
                value: "2",
                label: "选项2",
            },
            {
                value: "3",
                label: "选项3",
            },
        ],
        required: true,
        defaultValue: []
    },
    {
        group: "basic",
        type: "input",
        name: "填写题",
        title: "请填写本项内容",
        required: true,
        defaultValue: ""
    },
    {
        group: "basic",
        type: "textarea",
        name: "简述题",
        title: "请简要回答本项内容",
        required: true,
        defaultValue: ""
    },
    {
        group: "basic",
        type: "select",
        name: "下拉选项",
        title: "请选择一个选项",
        options: [
            {
                value: "1",
                label: "选项1",
            },
            {
                value: "2",
                label: "选项2",
            },
            {
                value: "3",
                label: "选项3",
            },
        ],
        required: true,
        defaultValue: ""
    },
    {
        group: "basic",
        type: "rate",
        name: "评分题",
        title: "请为本项进行评分",
        max: 5,
        required: true,
        defaultValue: ""
    },
    // 基础题型 - end

    // 上传题型 - start
    {
        group: "upload",
        type: "img-upload",
        icon: "icon-img-upload",
        name: "图片上传",
        title: "请选择要上传的图片",
        required: true,
        fileMaxCount: 1,
        fileMaxSize: 1,
    },
    {
        group: "upload",
        type: "file-upload",
        icon: "icon-file-upload",
        name: "文件上传",
        title: "请选择要上传的文件",
        required: true,
        fileMaxCount: 1,
        fileMaxSize: 1,
    },
    // 上传题型 - end

    // 日期题型 - start
    {
        group: "datetime",
        type: "date",
        name: "日期",
        title: "请选择一个日期",
        required: true,
        defaultValue: "",
        format: "date"
    },
    {
        group: "datetime",
        type: "time",
        name: "时间",
        title: "请选择一个时间",
        required: true,
        defaultValue: "",
        format: "time"
    },
    {
        group: "datetime",
        type: "month",
        name: "月份",
        title: "请选择一个月份",
        required: true,
        defaultValue: "",
        format: "month"
    },
    // 日期题型 - end

    // 矩阵题型 - start
    {
        group: "matrix",
        type: "matrix-radio",
        name: "矩阵单选",
        title: "请为每行选择一个选项",
        options: [
            {
                value: "1",
                label: "选项1",
            },
            {
                value: "2",
                label: "选项2",
            },
            {
                value: "3",
                label: "选项3",
            },
        ],
        rows: [
            { id: "1", title: "第1行" },
            { id: "2", title: "第2行" }
        ],
        required: true,
    },
    {
        group: "matrix",
        type: "matrix-checkbox",
        name: "矩阵多选",
        title: "请为每行选择选项",
        options: [
            {
                value: "1",
                label: "选项1",
            },
            {
                value: "2",
                label: "选项2",
            },
            {
                value: "3",
                label: "选项3",
            },
        ],
        required: true,
    },
    {
        group: "matrix",
        type: "matrix-rate",
        name: "矩阵评分",
        title: "请为每行进行评分",
        max: 5,
        rows: [
            { id: "1", title: "第1行" },
            { id: "2", title: "第2行" }
        ],
        required: true,
        defaultValue: ""
    },
    // 矩阵题型 - end
];

const componentGroup = [
    { id: "basic", name: "基础题型" },
    { id: "datetime", name: "时间题型" },
    { id: "upload", name: "上传题型" },
    { id: "matrix", name: "矩阵题型" }
];

let getComponentName = function (type) {
    for (let i = 0; i < componentList.length; i++) {
        let c = componentList[i];
        if (c.type == type) {
            return c.name;
        }
    }
    return "";
};

let getComponentByType = function (type) {
    for (let i = 0; i < componentList.length; i++) {
        let c = componentList[i];
        if (c.type == type) {
            return c;
        }
    }
    return null;
};

let getComponentByName = function (name) {
    for (let i = 0; i < componentList.length; i++) {
        let c = componentList[i];
        if (c.name == name) {
            return c;
        }
    }
    return null;
};

export { componentList, componentGroup, getComponentName, getComponentByType, getComponentByName };